<template>
    <b-card v-if="localUserData.subscriptionTier == 'paid' && 
        (typeof subscriptionDetails.cancelAt == 'undefined' || subscriptionDetails.cancelAt === null)" 
        title="Update Credit Card">
                                
        <p>
            To update your credit card information, enter the new information below and
            then click the Change button.  This change affects your next invoice.
        </p>
        
        <b-form @submit="submitPaymentCardChange">
        
            <b-form-group
                id="group-paymentCard"
                description=""
                label="Payment Details"
                label-for="updatedPaymentCard"
                :invalid-feedback="localFormValidation.cardMessage"
                :state="localFormValidation.cardError">
                
                    <StripeField
                        parentId="group-paymentCard"
                        id="updatedPaymentCard"
                        ref="updatedPaymentCard"
                        @statusUpdate:StripeField="handleStripeFieldStatusUpdate"
                        @newPaymentMethod:StripeField="handleStripeNewPaymentMethod"/>

                <b-form-text>
                    Your payment card information (securely processed using <a href="https://www.stripe.com">Stripe</a>).
                </b-form-text>
                
            </b-form-group>


            <b-card-footer style="text-align:right">
                <b-button ref="buttonChangePaymentCard" type="submit" variant="success">Change</b-button>
            </b-card-footer>
        </b-form>

    </b-card>
</template>

<script>

import genericOps from '@/mixins/genericOps'
import LocalStripeService from '@/services/LocalStripeService'
import StripeField from '@/components/StripeField.vue'

export default {
    name: 'UpdatePaymentCard',
    components: {
        StripeField
    },
    mixins: [
        genericOps
    ],
    props: {
        subscriptionDetails: {
            type: Object,
            default: {}
        },
        userData: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            formData: {
                newSubscriptionTier: null,
                newSubscriptionLevel: null,
            },
            formValidation: {
                cardMessage: null,
                newSubscriptionTier: null,
                newSubscriptionLevel: null,
            },
        }
    },
    computed: {
        localFormData: {
            get: function() {
                
                return this.formData
            
            },
            set: function(newValue) {
                this.formData = newValue
            }
        },
        localFormValidation: {
            get: function() {
                
                return this.formValidation
            
            },
            set: function(newValue) {
            }
        },
        localUserData: {
            get: function() {
                
                return this.userData
            
            },
            set: function(newValue) {
            }
        }
    },
    methods: {
        handleStripeFieldStatusUpdate(data) {
            
            //console.log(data)

            this.$set(this.localFormValidation, 'cardError', data.cardError)
            this.$set(this.localFormValidation, 'cardMessage', data.cardMessage)

        },
        handleStripeNewPaymentMethod(){
        
            this.$refs.updatedPaymentCard.configureStripe()
            this.$refs.buttonChangePaymentCard.disabled = false
            this.$emit('paymentCardUpdated:UpdatePaymentCard')
        
        },
        submitPaymentCardChange(evt) {
            
            evt.preventDefault()

            //console.log('UpdatePaymentCard.submitPaymentCardChange started.')
            
            this.$refs.buttonChangePaymentCard.disabled = true

            //console.log('Subscription Details: ')
            //console.log(this.subscriptionDetails)

            let updatedPaymentMethod = {}
            
            this.$refs.updatedPaymentCard.createNewStripePaymentMethod(this.localUserData.stripeCustomerId, this.localUserData.subscriptionLevel)

        }
    }
}
</script>

<style scoped>

</style>